import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap } from 'rxjs/operators';
import { AdminCentralActions } from './admin-central.actions';
import { AdminCentralService } from './admin-central.service';

@Injectable()
export class AdminCentralEffects {
    constructor(
        private actions$: Actions,
        private adminCentralService: AdminCentralService) {
    }

    getResourcesFromAppointments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(AdminCentralActions.getResources),
            switchMap((action: any) =>
                this.adminCentralService.getResourcesFromAppointment(action.userId)
                    .pipe(
                        map((response: any) =>
                            AdminCentralActions
                                .getResourcesSuccess({resources: response})
                        )
                    )
            )
        )
    );

}
